module.exports = __webpack_public_path__ + "r-v3/img/popup_close.97cc4eee.svg";